var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBranding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#E00E62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9995 28.0418C20.9995 23.5941 24.5872 20 28.9986 20C32.9017 20 36.16 22.8136 36.859 26.5426H28.3186C27.4902 26.5426 26.8186 27.2141 26.8186 28.0426V35.7812C23.4636 34.8277 20.9995 31.7279 20.9995 28.0418ZM26.8186 38.8669C21.7842 37.8511 17.9995 33.3859 17.9995 28.0418C17.9995 21.9499 22.9176 17 28.9986 17C34.572 17 39.1686 21.1582 39.8971 26.5426H45.9598C46.7882 26.5426 47.4598 27.2141 47.4598 28.0426V45.7631C47.4598 46.5915 46.7882 47.2631 45.9598 47.2631H28.3186C27.4902 47.2631 26.8186 46.5915 26.8186 45.7631V38.8669ZM29.8186 44.2631V29.5426H44.4598V44.2631H29.8186Z",
    fill: "#FFF5EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBranding);
export default __webpack_public_path__ + "static/media/icon-branding.e6c269c615970dfac161a77d1945f52d.svg";
export { ForwardRef as ReactComponent };